import React from "react";
import { OrderTransactionResponse } from "../../../../service/customer/order-workflow-service";
import { currencyMap } from "../../../../model/common/money";
import styles from "../solar-journey.module.scss";

interface Props {
	data: OrderTransactionResponse;
}

const formatMoney = (money?: { currency: string; amount: number }) => {
	if (!money) return "-";
	const symbol = currencyMap[money.currency] ?? money.currency;
	return `${symbol} ${money.amount.toLocaleString()}`;
};

const StarIcon = () => (
	<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M7 0L8.5716 4.83688L13.6574 4.83688L9.5429 7.82624L11.1145 12.6631L7 9.67376L2.8855 12.6631L4.4571 7.82624L0.342604 4.83688L5.4284 4.83688L7 0Z"
			fill="var(--app-tooltip-bg)"
		/>
	</svg>
);

const formatCurrency = (amount: number) => {
	return `₦${amount.toLocaleString()}`;
};

export const ProductDetailsSection: React.FC<Props> = ({ data }) => {
	const product = data.details.productDetails;
	const costOverview = data.details.costOverview;
	const monthlyPayment = data.details.monthlyPaymentDetails;
	const firstImage = product?.images?.[0];

	return (
		<div className={styles.productCard}>
			{firstImage && (
				<div className={styles.productImage}>
					<img src={firstImage.imageUrl} alt={product.productName} />
				</div>
			)}

			<div className={styles.badgesRow}>
				<div className={styles.badgesLeft}>
					<span className={styles.brandBadge}>{product.batteryType || "Solar"}</span>
					<span className={styles.stockBadge}>In Stock</span>
				</div>
				<div className={styles.ratingBadge}>
					<StarIcon />
					<span>4.7</span>
				</div>
			</div>

			<div className={styles.productName}>{product.productName}</div>

			<div className={styles.costRow}>
				<span className={styles.costLabel}>Package Cost</span>
				<span className={styles.costValue}>{formatMoney(costOverview?.totalAmount)}</span>
			</div>

			<div className={styles.descriptionRow}>
				<span className={styles.descriptionLabel}>Product Description</span>
			</div>

			<div className={styles.specsRow}>
				{product.activeDuration > 0 && (
					<span className={styles.specItem}>Up to {product.activeDuration} Hours</span>
				)}
				<span className={styles.specItem}>{product.batteryType || "-"}</span>
				{monthlyPayment && monthlyPayment.durationOfPaymentsInMonths > 0 && (
					<span className={styles.specItem}>
						1 — {Math.ceil(monthlyPayment.durationOfPaymentsInMonths / 12)} Years Plan
					</span>
				)}
			</div>
		</div>
	);
};
